import { render, staticRenderFns } from "./StaffMsg.vue?vue&type=template&id=5e67e10c&scoped=true"
import script from "./StaffMsg.vue?vue&type=script&lang=js"
export * from "./StaffMsg.vue?vue&type=script&lang=js"
import style0 from "./StaffMsg.vue?vue&type=style&index=0&id=5e67e10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e67e10c",
  null
  
)

export default component.exports